import React from 'react';

import StrapiText from '../../text/strapi-markdown-text-snippet';

import { FullWidthContentType } from '../../../models/strapi/full_width_content';

import { colors } from '../../../shared/colors';

import * as styles from '../strapi-full-width-content.module.scss';

interface Props {
    data: FullWidthContentType;
}

const TextBanner = ({ data }: Props) => {
    return (
        <div
            className={
                data.padSides ? `${styles[data.variant]} ${styles.padSides}` : styles[data.variant]
            }
            style={{
                backgroundColor:
                    data.backgroundColor && data.backgroundColor.backgroundColor
                        ? colors[data.backgroundColor.backgroundColor]
                        : 'transparent'
            }}>
            {data.text && data.text.text
                ? data.text.text.map((text, i) => <StrapiText data={text} key={i} />)
                : null}
        </div>
    );
};

export default TextBanner;
